import { EntelligenceMark } from '@/app/(onboard)/onboarding/components/EntelligenceMark';

// The onboarding intro's settled mark on the intro's surface, shown while /login decides.
export default function LoginStatus() {
  return (
    <div
      role="status"
      aria-label="Signing you in"
      className="flex w-full h-screen items-center justify-center bg-ds-surface-off-white"
    >
      <EntelligenceMark className="size-28 text-ds-brand-subtle drop-shadow-[0_0_14px_rgba(189,210,155,0.22)]" />
    </div>
  );
}
